import React from 'react'
import NavbarComponent from '../components/NavbarComponent'
import ContactSection from '../components/ContactSection'
import FooterSection from '../components/FooterSection'

function ContactPage() {
    return (
        <div>
            <div
                style={{
                    backgroundColor: "#f9fafb",
                }}
            >
                <NavbarComponent />
            </div>
            <ContactSection />
            <FooterSection />
        </div>
    )
}

export default ContactPage
